import { AlertIcon } from '@anyx/shared-icons';

import { Card } from '../card';

export interface ErrorCardProps {
  title: string;
  guideline?: string;
  note?: string;
  content?: React.ReactNode;
  iconColor?: string;
}

export const ErrorCard = ({
  title,
  guideline,
  note,
  content,
  iconColor = 'fill-warning',
}: ErrorCardProps) => {
  return (
    <Card className="m-auto flex max-w-lg flex-col items-center">
      <AlertIcon className={iconColor} />
      <h2 className="pt-5 pb-4 font-semibold">{title}</h2>
      {guideline && <div className="pt-4 pb-5">{guideline}</div>}
      {note && <small className="mt-2 pb-5 font-semibold">{note}</small>}
      {content}
    </Card>
  );
};
